import { colorConstants } from 'config/colorConstants';
import _, { isNull } from 'lodash';
import { fetchCurrency } from 'utils/helperMethods';

export const priceAlertDataParser = (data: any[], config: any, oldData: any, kpiName: string = '') => {
    const kpiScoreMapping: any = {
        index: [100, 0],
        percent_change: [0, 2],
        current_price: [0, 2],
    };

    try {
        const currency = fetchCurrency(config);
        const priceTrackingConfig = config?.priceTracking;
        let oldDataLength = oldData?.tableData?.length || 0;
        let result: any[] = [];
        data?.forEach((dataItem: any) => {
            const temp: any = {};
            temp['label'] = dataItem?.rowAttributeName;
            dataItem?.columnData?.forEach((colData: any) => {
                const priceChangeData = JSON.parse(colData?.priceChangeData);
                const nestedDataTemp: any = {};
                Object.keys(priceChangeData).map((item: any) => {
                    nestedDataTemp[item] = {
                        pre:
                            priceTrackingConfig?.kpiMapping?.[dataItem?.rowAttributeName]?.[0] ||
                            (dataItem?.isExpandable && kpiName === 'current_price')
                                ? currency
                                : '',
                        post:
                            priceTrackingConfig?.kpiMapping?.[dataItem?.rowAttributeName]?.[1] ||
                            (dataItem?.isExpandable && kpiName !== 'index' && kpiName !== 'current_price')
                                ? '%'
                                : '',
                        val:
                            kpiName === 'index' && dataItem?.isExpandable && !_.isNil(priceChangeData[item])
                                ? _.round(priceChangeData[item], 0)
                                : priceChangeData[item],
                        color:
                            _.isNil(priceChangeData[item]) || (dataItem?.isExpandable && kpiName === 'current_price')
                                ? undefined
                                : _.round(priceChangeData[item], kpiScoreMapping[kpiName][1]) >
                                  kpiScoreMapping[kpiName][0]
                                ? colorConstants.limeGreen
                                : _.round(priceChangeData[item], kpiScoreMapping[kpiName][1]) <
                                  kpiScoreMapping[kpiName][0]
                                ? colorConstants.red
                                : colorConstants.orangeAlt,
                    };
                });
                temp[colData?.colAttributeName] = { nested: { ...nestedDataTemp } };
            });
            temp['isExpandable'] = dataItem?.isExpandable;
            temp['nestedIndex'] = _.isNull(dataItem?.itemIndex)
                ? dataItem?.itemIndex
                : oldDataLength + dataItem?.itemIndex;
            result.push(temp);
        });
        return result;
    } catch (error) {
        throw error;
    }
};
